import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GridOptions, GridApi } from 'ag-grid-community';

@Component({
  selector: 'app-common-grid-wrapper',
  templateUrl: './common-grid-wrapper.component.html',
  styleUrls: ['./common-grid-wrapper.component.css']
})
export class CommonGridWrapperComponent implements OnInit {

  rowClassRules;
  // @Input() gridOptions;
  @Input() columnDefs = [];
  @Input() rowData = [];
  @Output() editClick: EventEmitter<any> = new EventEmitter();
  @Output() deleteClick: EventEmitter<any> = new EventEmitter();
  @Output() viewDocClick: EventEmitter<any> = new EventEmitter();
  @Output() lockClick: EventEmitter<any> = new EventEmitter();
  @Output() activeClick: EventEmitter<any> = new EventEmitter();
  @Output() resetClick: EventEmitter<any> = new EventEmitter();
  @Output() openClick: EventEmitter<any> = new EventEmitter();
  @Output() deleterecordClick: EventEmitter<any> = new EventEmitter();
  @Output() departmentPermissionClick: EventEmitter<any> = new EventEmitter();
  @Output() accessPermissionClick: EventEmitter<any> = new EventEmitter();

  numberOfRowsPerPage = 10;
  pageList = [
    10, 20, 50, 100
  ];
  gridAPI: GridApi;
  gridOptions = <GridOptions>{
    context: {
      componentParent: this
    },
    isExternalFilterPresent: () => true,
    doesExternalFilterPass: node => node.data.isVisible,
    getRowHeight: (params) => {
      return 37;
    },
    // getRowWidth: (params) => {
    //   return 40;
    // },
    onGridReady: (params) => {
      this.gridAPI = params.api;
      params.api.sizeColumnsToFit();
    },
    onGridSizeChanged: (params) => {
      params.api.sizeColumnsToFit();
    },
    icons: {
      sortNone: '<i class="fa fa-sort"/>',
      sortAscending: '<i class="fa fa-sort-alpha-asc"/>',
      sortDescending: '<i class="fa fa-sort-alpha-desc"/>'
    },
    pagination: true,
    paginationPageSize: this.numberOfRowsPerPage,
    headerHeight: 50,
  };

  updateNumberOfRowsPerPage() {
    this.gridAPI.paginationSetPageSize(this.numberOfRowsPerPage);
    this.gridAPI.sizeColumnsToFit();
  }

  constructor() { }

  ngOnInit() {
    this.rowClassRules = {
      'group-row': (params) => {
        return params.data.groupLevel === 0;
      },
    };
  }
  onEdit(params) {
    this.editClick.emit(params);
  }

  onDelete(params) {
    this.deleteClick.emit(params);
  }

  docClick(params) {
    this.viewDocClick.emit(params);
  }

  isLockUser(params) {
    this.lockClick.emit(params);
  }

  isActiveUser(params) {
    this.activeClick.emit(params);
  }

  resetPassword(params) {
    this.resetClick.emit(params);
  }
  modelOpen(params) {
    this.openClick.emit(params);
  }
  deleterecord(params) {
    this.deleterecordClick.emit(params);
  }
  departmentPermission(params) {
    this.departmentPermissionClick.emit(params);
  }
  accessPermission(params) {
    this.accessPermissionClick.emit(params);
  }
}
